import { UserRolePermission } from '@schooly/api';
import { useAuth } from '@schooly/components/authentication';

import { canEditAttendanceEntries } from '../Attendance/permissions';

export const TEACHER_DASHBOARD_PERMISSIONS: UserRolePermission[] = [
  'group_viewer',
  'message_viewer',
  'timetable_viewer',
  'assessment_viewer',
];

export function useTeacherDashboardPermissions() {
  const { permissions } = useAuth();

  const canViewGroups = permissions.includes('group_viewer');
  const canViewAttendance = permissions.includes('attendance_viewer');
  const canManageAttendance = canEditAttendanceEntries(permissions);
  const canViewAssessments = permissions.includes('assessment_viewer');
  const canManageAssessments =
    permissions.includes('assessment_creator') || permissions.includes('assessment_manager');
  const canViewReports = permissions.includes('assessment_viewer');
  const canViewTimetable = permissions.includes('timetable_viewer');
  const canViewMessages = permissions.includes('message_viewer');

  const canViewTeacherDashboard = TEACHER_DASHBOARD_PERMISSIONS.some((p) =>
    permissions.includes(p),
  );

  return {
    canViewTeacherDashboard,
    canViewGroups,
    canViewAttendance,
    canManageAttendance,
    canViewAssessments,
    canManageAssessments,
    canViewReports,
    canViewTimetable,
    canViewMessages,
  };
}
